import { useState } from 'react';
import { Card, Badge, Button } from '@atoms/index';
import { cn } from '@/utils/cn';
import type { Review } from '@/types';

interface ReviewListProps {
  reviews: Review[];
  isLoading?: boolean;
  onRespond?: (reviewId: string) => void;
}

export function ReviewList({ reviews, isLoading, onRespond }: ReviewListProps) {
  if (isLoading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4" />
        <p className="text-gray-600">Yorumlar yükleniyor...</p>
      </div>
    );
  }

  if (reviews.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        <p>Henüz yorum yok</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {reviews.map((review) => (
        <Card key={review.id} className="p-4">
          <div className="space-y-3">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        className={cn(
                          'text-lg',
                          star <= review.rating ? 'text-yellow-400' : 'text-gray-300',
                        )}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                  <Badge variant="info">{review.rating}/5</Badge>
                </div>
                {review.comment && (
                  <p className="text-gray-700 mb-2">{review.comment}</p>
                )}
                <p className="text-xs text-gray-500">
                  {new Date(review.createdAt).toLocaleString('tr-TR')}
                </p>
              </div>
            </div>

            {review.restaurantResponse ? (
              <div className="mt-3 pt-3 border-t bg-gray-50 rounded-lg p-3">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-sm font-medium text-gray-700">Restoran Yanıtı:</span>
                  <span className="text-xs text-gray-500">
                    {review.restaurantResponseAt
                      ? new Date(review.restaurantResponseAt).toLocaleString('tr-TR')
                      : ''}
                  </span>
                </div>
                <p className="text-sm text-gray-700">{review.restaurantResponse}</p>
              </div>
            ) : (
              onRespond && (
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={() => onRespond(review.id)}
                  className="mt-2"
                >
                  Yanıtla
                </Button>
              )
            )}
          </div>
        </Card>
      ))}
    </div>
  );
}
